import { render, staticRenderFns } from "./page-faq.vue?vue&type=template&id=6143684e&scoped=true"
import script from "./page-faq.vue?vue&type=script&lang=js"
export * from "./page-faq.vue?vue&type=script&lang=js"
import style0 from "./page-faq.vue?vue&type=style&index=0&id=6143684e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6143684e",
  null
  
)

export default component.exports